import { Component, OnInit }                    from '@angular/core';
import { Router, ActivatedRoute, Params }       from '@angular/router';
import { Location }                             from '@angular/common';
import { FormControl, FormGroup, Validators }   from '@angular/forms';
import 'rxjs/add/operator/switchMap';


export class SpainshService {

  constructor() { }

  private answers: any [];
  private correct: any;

  private Spanish = [
    {
      "number": 1,
      "description": "De acuerdo al texto, ¿qué se puede concluir?",
      "options": [
        { "description": "a) Los embarazos traumáticos determinan por completo el comportamiento genético del recién nacido.", "value": "a" },
        { "description": "b) Un feto que se desarrolla bajo circunstancias complicadas durante el proceso del embarazo seguro tendrá esquizofrenia.", "value": "b" },
        { "description": "c) El texto no descarta la posibilidad de que en ciertos casos una predisposición genética sea la causa principal de la esquizofrenia.", "value": "c" },
        { "description": "d) Es muy posible que un niño que nazca bajo circunstancias regulares durante el proceso de su concepción, tenga esquizofrenia.", "value": "d" }
      ],
      "answer": "c"
    },

    {
      "number": 2,
      "description": "La expresión 'La causa' se refiere a...",
      "options": [
        { "description": "a) El móvil del asesinato.", "value": "a" },
        { "description": "b) La investigación.", "value": "b" },
        { "description": "c) La verdad sobre el caso.", "value": "c" },
        { "description": "d) el cuerpo de policías.", "value": "d" }
      ],
      "answer": "b"
    },

    {
      "number": 3,
      "description": "La expresión “siento todo y no siento nada al encontrarme solo” es un ejemplo de la figura retórica conocida como...",
      "options": [
        { "description": "a) Prosopopeya.", "value": "a" },
        { "description": "b) Paradoja.", "value": "b" },
        { "description": "c) Antítesis.", "value": "c" },
        { "description": "d) Símil.", "value": "d" }
      ],
      "answer": "c"
    },

    {
      "number": 4,
      "description": "¿Cuál de los siguientes enunciados le añade información y enriquece ESTILÍSTICAMENTE la secuencia de los enunciados del Segmento anterior sin negar lo que en ellos se expresa?",
      "options": [
        { "description": "a) ...al pie del mismo árbol.", "value": "a" },
        { "description": "b) ...se regocijaron con su platillo.", "value": "b" },
        { "description": "c) ...le dolió el no poder vengarse.", "value": "c" },
        { "description": "d) ...el usual consuelo de los débiles e impotentes...", "value": "d" }
      ],
      "answer": "a"
    },

    {
      "number": 5,
      "description": "¿Cuál de los siguientes enunciados del Segmento anterior se refiere INDIRECTAMENTE al lugar donde los Argonautas avistaron a las sirenas?",
      "options": [
        { "description": "a) ...en su nave...", "value": "a" },
        { "description": "b) ...el sitio fatal...", "value": "b" },
        { "description": "c) ...al mar...", "value": "c" },
        { "description": "d) ...en las profundidades del océano...", "value": "d" }
      ],
      "answer": "b"
    },
  ];

  private descriptions = [
    {
      "description": "Durante décadas, los investigadores han observado que las personas cuyas madres pasan por embarazos complicados tienen tasas más altas de la esquizofrenia, pero nadie sabía a qué se debía. De alguna manera ¿podrían los embarazos traumáticos comprometer el desarrollo del cerebro del feto, causando la esquizofrenia? ¿O es al revés: los genes que causan la esquizofrenia también dan lugar a reacciones adversas en el útero? Ahora, por primera vez, los científicos tienen pruebas de que las complicaciones graves del embarazo pueden activar ciertos genes de la esquizofrenia. Los resultados tienen implicaciones importantes para futuras investigaciones sobre cómo ciertos acontecimientos en el embarazo de una mujer pueden cambiar la forma en que los genes de su hijo se comportan. "
    },

    {
      "description": "Una verdad que nunca se encontró. Las primeras sospechas hablaron de un homicidio por encargo. Policía y Justicia nunca dieron a conocer la profundidad de las investigaciones. La causa estaría en punto muerto. ",
    },

    {
      "description": "Era de noche y yo caminaba por un bosque, cuando en la lejanía observé a una mujer blanca como la luna, cerré los ojos por un segundo y ya no había nada, me fui para mi casa, llegué y sentí incertidumbre, miedo y tristeza, siento todo y no siento nada al encontrarme solo.",
    },

    {
      "description": "Un águila y una zorra que eran muy amigas decidieron vivir juntas con la idea de que eso reforzaría su amistad. Entonces el águila escogió un árbol muy elevado para poner allí sus huevos, mientras que la zorra soltó a sus hijos bajo unas zarzas sobre la tierra al pie del mismo árbol. Un día que la zorra salió a buscar su comida, el águila, que estaba hambrienta cayó sobre las zarzas, se llevó a los zorruelos, y entonces ella y sus crías se regocijaron con su platillo. Regresó la zorra y más le dolió el no poder vengarse, que saber de la muerte de sus pequeños; ¿Cómo podría ella, siendo un animal terrestre, sin poder volar, perseguir a uno que vuela? Tuvo que conformarse con el usual consuelo de los débiles e impotentes: maldecir desde lejos a su enemigo. ",
    },

    {
      "description": "Cuando los Argonautas pasaron en su nave por el sitio fatal, las sirenas cantaron para atraerles; pero Orfeo cantó con más dulzura y las eclipsó con los acentos de su lira. Y, como según tenía dispuesto el destino, la vida de las sirenas debía cesar en el momento que alguien escuchara sus cantos sin sentir el hechizo que estos producían, se precipitaron al mar y quedaron convertidas en rocas, sumergiéndose en las profundidades del océano.",
    },
  ];

  private titles = [
    {
      "description": "Inferencia",
    },

    {
      "description": "Expresión escrita",
    },

    {
      "description": "Figuras retóricas",
    },

    {
      "description": "Adición",
    },

    {
      "description": "Particularización",
    },
  ];

  private explications = [
    {
      "description": "https://www.youtube.com/embed/Y2TdUWody84",
    },

    {
      "description": "https://www.youtube.com/embed/0d8guE94wuI",
    },

    {
      "description": "https://www.youtube.com/embed/F65aR1Yhv0Y",
    },

    {
      "description": "https://www.youtube.com/embed/za6Fyq7Xqfk",
    },

    {
      "description": "https://www.youtube.com/embed/PPLywcNbDio",
    },
  ];

  getQuestion(){
    return this.Spanish;
  }

  getDescription() {
    return this.descriptions;
  }

  getExplications() {
    return this.explications;
  }

  getTitle() {
    return this.titles;
  }

  setCorrectAnswers(corects: any) {
    // console.log("Recibio Español", corects);
    this.correct = corects;
  }

  getCorrectAnswers() {
    // console.log("Envio Español", this.correct);
      return this.correct;
  }

  setAnswers(aux: any[]) {
    this.answers = aux;
  }

  getAnswers() {
    return this.answers;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/spanish.service.ts